import GroupDivisionsCard from '@/components/common/cards/group-divisions-card/GroupDivisionsCard';
import { Button } from '@/components/ui/button';
import { TServices } from '@/services/services';
import { TServiceDivision } from '@/services/servicesDivision';
import { useTranslation } from 'react-i18next';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';

const GroupDivisions: React.FC<{
  serviceDivisionGroups: TServiceDivision[];
  service: TServices;
}> = ({ serviceDivisionGroups, service }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex flex-col justify-between gap-4 md:flex-row">
        <p className="font-bold">
          {t('serviceDetail.divisionConfiguration.groupDivision')}
        </p>
        <Button asChild>
          <Link to={`./create-group`}>
            {t('serviceDetail.createServiceGroup.title')}
          </Link>
        </Button>
      </div>
      <Alert className="mt-4" variant="warning">
        <AlertTriangle className="w-4 h-4" />
        <AlertTitle>{t('common.warnings')}</AlertTitle>
        <AlertDescription>
          {t('serviceDetail.divisionConfiguration.groupDivisionWarning')}
        </AlertDescription>
      </Alert>
      {serviceDivisionGroups?.length > 0 ? (
        <div className="grid grid-cols-1 gap-4 mt-4 md:grid-cols-2">
          {[...serviceDivisionGroups].sort((a, b) => a.order - b.order).map((division) => (
            <GroupDivisionsCard
              key={division.id}
              division={division}
              service={service}
            />
          ))}
        </div>
      ) : (
        <div className="p-8 text-center text-gray-500 border rounded-md">
          {t('serviceDetail.divisionConfiguration.noGroupDivisions')}
        </div>
      )}
    </>
  );
};

export default GroupDivisions;
